import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { RepositoryCard } from './RepositoryCard';
import { RepositoryItem } from './RepositoryItem';
class RepositoriesList extends Component {
    constructor() {
        super(...arguments);
        this.renderItems = (repositories) => {
            const groupedRepositories = repositories.reduce((result, repository) => {
                const repositoryOwner = repository.getOwner();
                (result[repositoryOwner] = result[repositoryOwner] || []).push(repository);
                return result;
            }, {});
            const items = [];
            let sectionTitle = Object.keys(groupedRepositories).length > 0 ? Object.keys(groupedRepositories)[0] : '';
            let section = [];
            for (const group of Object.values(groupedRepositories)) {
                for (const repo of Object.values(group)) {
                    // @ts-expect-error TS18046: 'repo' is of type 'unknown'.
                    const lastIndexOf = repo.fullname.lastIndexOf('/');
                    // @ts-expect-error TS18046: 'repo' is of type 'unknown'.
                    const title = repo.fullname.substring(0, lastIndexOf);
                    if (title !== sectionTitle) {
                        items.push(this.renderHeader(sectionTitle), _jsx(Row, { noGutters: true, children: section }, sectionTitle + '_section'));
                        section = [];
                    }
                    // @ts-expect-error TS2345: Argument of type 'unknown' is not assignable to parameter of type 'Repository'.
                    section.push(this.renderRepositoryNew(repo));
                    sectionTitle = title;
                }
            }
            if (sectionTitle !== '') {
                items.push(this.renderHeader(sectionTitle), _jsx(Row, { noGutters: true, children: section }, sectionTitle + '_section'));
            }
            return items;
        };
        this.renderHeader = (title) => {
            return _jsx("h4", { className: "pt-3", children: title }, title);
        };
        this.renderRepositoryNew = (repository) => {
            const { allowInstallGha, gha, onRegisterWebhook, userId } = this.props;
            return (_jsx(Col, { xs: 12, sm: 6, md: 4, lg: 3, className: "repository-cards", children: _jsx(RepositoryCard, { repository: repository, allowInstallGha: allowInstallGha, gha: gha, userId: userId, onRegisterWebhook: onRegisterWebhook }) }, repository.id));
        };
    }
    render() {
        const { list, showGrid } = this.props;
        if (showGrid) {
            return _jsx(Container, { fluid: true, children: this.renderItems(list) });
        }
        return list.map((repository) => _jsx(RepositoryItem, { repository: repository }));
    }
}
RepositoriesList.defaultProps = {
    allowInstallGha: true,
    showGrid: false,
};
export default withTranslation()(RepositoriesList);
